import React from 'react'

const MissingPage = () => {
  return (
    <div>MissingPage</div>
  )
}

export default MissingPage